// Extracted from ClientGoogleFeedPreviewPage.js (Phase 2a split).
import { MousePointerClick, Search as SearchIcon, BarChart3, Youtube } from "lucide-react";
export const FIELD_CATALOG = {
  google_ads: {
    title: "Google Ads",
    icon: MousePointerClick,
    groups: [
      { label: "Performance · core", fields: [
        { key: "impressions", desc: "Impressions" },
        { key: "clicks", desc: "Clicks" },
        { key: "cost", desc: "Spend ($)" },
        { key: "ctr", desc: "CTR %" },
        { key: "average_cpc", desc: "Avg. CPC ($)" },
        { key: "conversions", desc: "Conversions" },
        { key: "cost_per_conversion", desc: "Cost / conversion" },
        { key: "conversion_rate", desc: "Conversion rate %" },
      ]},
      { label: "Performance · extended", advanced: true, fields: [
        { key: "average_cpm", desc: "Avg. CPM ($)" },
        { key: "average_cpv", desc: "Avg. CPV (video)" },
        { key: "average_cpe", desc: "Avg. cost per engagement" },
        { key: "interactions", desc: "Interactions (any)" },
        { key: "interaction_rate", desc: "Interaction rate %" },
        { key: "engagements", desc: "Engagements" },
        { key: "engagement_rate", desc: "Engagement rate %" },
        { key: "active_view_impressions", desc: "Active View impressions" },
        { key: "active_view_viewability", desc: "Active View viewability %" },
      ]},
      { label: "Video metrics", advanced: true, fields: [
        { key: "video_views", desc: "Video views" },
        { key: "video_view_rate", desc: "View rate %" },
        { key: "video_quartile_p25_rate", desc: "25 % quartile rate" },
        { key: "video_quartile_p50_rate", desc: "50 % quartile rate" },
        { key: "video_quartile_p75_rate", desc: "75 % quartile rate" },
        { key: "video_quartile_p100_rate", desc: "100 % completed" },
      ]},
      { label: "Conversions · extended", advanced: true, fields: [
        { key: "all_conversions", desc: "All conversions (incl. cross-device)" },
        { key: "all_conversions_value", desc: "All conversions value ($)" },
        { key: "conversions_value", desc: "Conversions value ($)" },
        { key: "value_per_conversion", desc: "Value / conversion" },
        { key: "value_per_all_conversions", desc: "Value / all conversions" },
        { key: "view_through_conversions", desc: "View-through conversions" },
      ]},
      { label: "Auction insights / share-of-voice", advanced: true, fields: [
        { key: "search_impression_share", desc: "Search impression share %" },
        { key: "search_top_impression_share", desc: "Top IS %" },
        { key: "search_absolute_top_impression_share", desc: "Abs. top IS %" },
        { key: "search_rank_lost_impression_share", desc: "Rank-lost IS %" },
        { key: "search_budget_lost_impression_share", desc: "Budget-lost IS %" },
        { key: "content_impression_share", desc: "Display IS %" },
        { key: "content_budget_lost_impression_share", desc: "Display budget-lost IS %" },
      ]},
      { label: "Phone / lead", advanced: true, fields: [
        { key: "phone_calls", desc: "Phone calls" },
        { key: "phone_impressions", desc: "Phone impressions" },
        { key: "phone_through_rate", desc: "PTR %" },
      ]},
      { label: "Breakdowns · structure", advanced: true, fields: [
        { key: "by_campaign", desc: "Per-campaign rows" },
        { key: "by_ad_group", desc: "Per-ad-group rows" },
        { key: "by_keyword", desc: "Per-keyword rows" },
        { key: "by_ad", desc: "Per-ad rows" },
        { key: "by_landing_page", desc: "Per landing page" },
      ]},
      { label: "Breakdowns · segments", advanced: true, fields: [
        { key: "by_device", desc: "Device split" },
        { key: "by_network", desc: "Search / Display / YouTube" },
        { key: "by_click_type", desc: "Click type (headline / sitelink / call …)" },
        { key: "by_day", desc: "Daily series" },
        { key: "by_day_of_week", desc: "Day-of-week split" },
        { key: "by_hour", desc: "Hour-of-day split" },
        { key: "by_country", desc: "Country split" },
        { key: "by_region", desc: "Region split" },
        { key: "by_match_type", desc: "Keyword match type" },
        { key: "by_quality_score", desc: "Quality score buckets" },
        { key: "by_conversion_action", desc: "Per conversion action" },
      ]},
    ],
  },

  search_console: {
    title: "Google Search Console",
    icon: SearchIcon,
    groups: [
      { label: "Totals", fields: [
        { key: "clicks", desc: "Total clicks" },
        { key: "impressions", desc: "Total impressions" },
        { key: "ctr", desc: "CTR %" },
        { key: "avg_position", desc: "Average position" },
      ]},
      { label: "Breakdowns", advanced: true, fields: [
        { key: "top_queries", desc: "Top 100 search queries" },
        { key: "top_pages", desc: "Top 100 landing pages" },
        { key: "by_country", desc: "Country split" },
        { key: "by_device", desc: "Device split (desktop / mobile / tablet)" },
        { key: "by_day", desc: "Daily series" },
        { key: "by_search_appearance", desc: "Search appearance (AMP, rich results, FAQs, How-tos …)" },
      ]},
      { label: "Search-type splits", advanced: true, fields: [
        { key: "search_type_web", desc: "Web search totals" },
        { key: "search_type_image", desc: "Image search totals" },
        { key: "search_type_video", desc: "Video search totals" },
        { key: "search_type_news", desc: "News search totals" },
        { key: "search_type_discover", desc: "Discover feed totals" },
      ]},
    ],
  },

  analytics_ga4: {
    title: "Google Analytics (GA4)",
    icon: BarChart3,
    groups: [
      { label: "Audience · core", fields: [
        { key: "sessions", desc: "Sessions" },
        { key: "active_users", desc: "Active users" },
        { key: "new_users", desc: "New users" },
        { key: "total_users", desc: "Total users" },
        { key: "pageviews", desc: "Page views" },
        { key: "engagement_rate", desc: "Engagement rate %" },
        { key: "average_session_duration", desc: "Avg. session duration (s)" },
      ]},
      { label: "Conversions · core", fields: [
        { key: "conversions", desc: "Conversions" },
        { key: "revenue", desc: "Total revenue ($)" },
        { key: "purchases", desc: "Purchases" },
      ]},

      { label: "Engagement · extended", advanced: true, fields: [
        { key: "engaged_sessions", desc: "Engaged sessions" },
        { key: "sessions_per_user", desc: "Sessions / user" },
        { key: "user_engagement_duration", desc: "Total engagement (s)" },
        { key: "screen_page_views_per_session", desc: "Views / session" },
        { key: "bounce_rate", desc: "Bounce rate %" },
        { key: "scrolled_users", desc: "Scrolled users" },
        { key: "event_count", desc: "Event count" },
        { key: "events_per_session", desc: "Events / session" },
        { key: "active_1_day_users", desc: "1-day active users" },
        { key: "active_7_day_users", desc: "7-day active users" },
        { key: "active_28_day_users", desc: "28-day active users" },
      ]},
      { label: "Acquisition", advanced: true, fields: [
        { key: "first_user_source", desc: "First-touch source (top 50)" },
        { key: "first_user_medium", desc: "First-touch medium" },
        { key: "first_user_campaign", desc: "First-touch campaign" },
        { key: "first_user_source_medium", desc: "First-touch source / medium" },
        { key: "session_source", desc: "Session source" },
        { key: "session_medium", desc: "Session medium" },
        { key: "session_campaign", desc: "Session campaign" },
        { key: "session_default_channel_group", desc: "Default channel group" },
      ]},
      { label: "E-commerce", advanced: true, fields: [
        { key: "transactions", desc: "Transactions" },
        { key: "average_purchase_revenue", desc: "Avg. order value" },
        { key: "items_purchased", desc: "Items purchased" },
        { key: "item_revenue", desc: "Item revenue" },
        { key: "add_to_carts", desc: "Add-to-carts" },
        { key: "checkouts", desc: "Begin checkout" },
        { key: "cart_to_view_rate", desc: "Cart / view rate %" },
        { key: "purchase_to_view_rate", desc: "Purchase / view rate %" },
        { key: "ecommerce_purchases", desc: "Ecommerce purchases" },
        { key: "arpu", desc: "ARPU (revenue / user)" },
        { key: "arppu", desc: "ARPPU (revenue / paying user)" },
        { key: "refunds", desc: "Refunds" },
        { key: "shipping_amount", desc: "Shipping amount" },
        { key: "tax_amount", desc: "Tax amount" },
      ]},
      { label: "Advertising", advanced: true, fields: [
        { key: "advertiser_ad_clicks", desc: "Ad clicks (cross-platform)" },
        { key: "advertiser_ad_cost", desc: "Ad cost ($)" },
        { key: "advertiser_ad_impressions", desc: "Ad impressions" },
        { key: "return_on_ad_spend", desc: "ROAS" },
      ]},

      { label: "Breakdowns · content & traffic", advanced: true, fields: [
        { key: "by_source", desc: "Top traffic sources" },
        { key: "by_medium", desc: "Top mediums" },
        { key: "by_source_medium", desc: "Source / medium combo" },
        { key: "by_campaign", desc: "Top campaigns" },
        { key: "by_channel_group", desc: "Default channel group" },
        { key: "by_landing_page", desc: "Landing page" },
        { key: "by_page", desc: "Top pages" },
        { key: "by_page_title", desc: "Top page titles" },
        { key: "by_event", desc: "Event name" },
      ]},
      { label: "Breakdowns · audience", advanced: true, fields: [
        { key: "by_country", desc: "Country split" },
        { key: "by_region", desc: "Region split" },
        { key: "by_city", desc: "City split" },
        { key: "by_language", desc: "Language split" },
        { key: "by_age", desc: "Age bracket" },
        { key: "by_gender", desc: "Gender" },
        { key: "by_user_type", desc: "New vs returning" },
      ]},
      { label: "Breakdowns · device & tech", advanced: true, fields: [
        { key: "by_device", desc: "Device category" },
        { key: "by_browser", desc: "Browser" },
        { key: "by_os", desc: "Operating system" },
        { key: "by_mobile_model", desc: "Mobile device model" },
        { key: "by_screen_resolution", desc: "Screen resolution" },
        { key: "by_app_version", desc: "App version" },
      ]},
      { label: "Breakdowns · time", advanced: true, fields: [
        { key: "by_day", desc: "Daily series" },
        { key: "by_week", desc: "Weekly series" },
        { key: "by_month", desc: "Monthly series" },
        { key: "by_hour", desc: "Hour of day" },
        { key: "by_day_of_week", desc: "Day of week" },
      ]},
    ],
  },

  youtube: {
    title: "YouTube",
    icon: Youtube,
    groups: [
      { label: "Channel · core", fields: [
        { key: "views", desc: "Views" },
        { key: "watch_time_minutes", desc: "Watch time (min)" },
        { key: "subscribers_gained", desc: "Subscribers gained" },
        { key: "subscribers_lost", desc: "Subscribers lost" },
        { key: "likes", desc: "Likes" },
        { key: "average_view_duration", desc: "Avg. view duration (s)" },
      ]},
      { label: "Engagement", advanced: true, fields: [
        { key: "dislikes", desc: "Dislikes" },
        { key: "comments", desc: "Comments" },
        { key: "shares", desc: "Shares" },
        { key: "videos_added_to_playlists", desc: "Videos added to playlists" },
        { key: "videos_removed_from_playlists", desc: "Videos removed from playlists" },
        { key: "average_view_percentage", desc: "Avg. view percentage" },
        { key: "annotation_click_through_rate", desc: "Annotation CTR" },
        { key: "annotation_close_rate", desc: "Annotation close rate" },
      ]},
      { label: "Cards & end-screens", advanced: true, fields: [
        { key: "card_impressions", desc: "Card impressions" },
        { key: "card_clicks", desc: "Card clicks" },
        { key: "card_click_rate", desc: "Card CTR" },
        { key: "end_screen_impressions", desc: "End-screen impressions" },
        { key: "end_screen_clicks", desc: "End-screen clicks" },
        { key: "end_screen_click_rate", desc: "End-screen CTR" },
      ]},
      { label: "Monetisation / Premium", advanced: true, fields: [
        { key: "estimated_revenue", desc: "Estimated revenue ($)" },
        { key: "estimated_ad_revenue", desc: "Estimated ad revenue ($)" },
        { key: "gross_revenue", desc: "Gross revenue ($)" },
        { key: "ad_impressions", desc: "Ad impressions" },
        { key: "cpm", desc: "CPM ($)" },
        { key: "playback_based_cpm", desc: "Playback CPM" },
        { key: "monetized_playbacks", desc: "Monetised playbacks" },
        { key: "red_views", desc: "YouTube Premium views" },
        { key: "red_watch_time_minutes", desc: "Premium watch time (min)" },
      ]},
      { label: "Breakdowns", advanced: true, fields: [
        { key: "by_video", desc: "Per-video rows (top 50)" },
        { key: "by_country", desc: "Country split" },
        { key: "by_traffic_source", desc: "Traffic source type" },
        { key: "by_day", desc: "Daily series" },
        { key: "by_device", desc: "Device type" },
        { key: "by_subscribed_status", desc: "Subscribed vs not" },
        { key: "by_playback_location", desc: "Playback location" },
        { key: "by_operating_system", desc: "Operating system" },
        { key: "by_youtube_product", desc: "YouTube product (main / Premium / Kids)" },
        { key: "by_live_or_on_demand", desc: "Live vs VOD" },
        { key: "by_age_group", desc: "Age group" },
        { key: "by_gender", desc: "Gender" },
        { key: "by_sharing_service", desc: "Sharing service" },
      ]},
    ],
  },
};

export const SVC_LABEL = {
  google_ads: "Google Ads",
  search_console: "Search Console",
  analytics_ga4: "Google Analytics",
  youtube: "YouTube",
};

// Services tied to a single website (BU) — Import to Report needs the admin
// to pick which property the data should write into.
export const SITE_SPECIFIC_SERVICES = new Set(["search_console", "analytics_ga4"]);

